function createWavyCircle(selector, { waves = 12, points = 240, radius = 0.43, waveDepth = 0.018 } = {}) {
	const path = document.querySelector(selector);

	if (!path) return;

	let d = "";

	for (let i = 0; i <= points; i++) {
		const angle = (i / points) * Math.PI * 2;
		const r = radius + Math.cos(angle * waves) * waveDepth;

		const x = 0.5 + Math.cos(angle) * r;
		const y = 0.5 + Math.sin(angle) * r;

		d += `${i === 0 ? "M" : "L"} ${x} ${y} `;
	}

	path.setAttribute("d", `${d}Z`);
}

createWavyCircle("#wavy-circle-path", {
	waves: 12,
	radius: 0.43,
	waveDepth: 0.018,
});

createWavyCircle("#wavy-icon-circle-path", {
	waves: 12,
	radius: 0.43,
	waveDepth: 0.018,
});
